import { Theme } from "@material-ui/core/styles";
import { cahTheme } from "./cahTheme";
import { msaTheme } from "./msaTheme";
import { amfamTheme } from "./afiTheme";

export enum OpcoThemeIdentifierType {
  AMFAM_IDENTIFIER = "C46502ED595BAD41",
  MSA_IDENTIFIER = "D8958C3071714434",
  CAH_IDENTIFIER = "B079C1C03BFC7C4B",
  POLARIS_IDENTIFIER = "963092DAF4D811ED",
  OSI_IDENTIFIER = "803B162B8BD14D8E",
}

let currentThemeName = "";

export default function getThemeById(opcoId: string): Theme {
  let themeName = "";
  switch (opcoId) {
    case OpcoThemeIdentifierType.AMFAM_IDENTIFIER:
      themeName = "amfamTheme";
      break;
    case OpcoThemeIdentifierType.MSA_IDENTIFIER:
      themeName = "msaTheme";
      break;
    case OpcoThemeIdentifierType.CAH_IDENTIFIER:
    case OpcoThemeIdentifierType.POLARIS_IDENTIFIER:
      themeName = "cahTheme";
      break;
    case OpcoThemeIdentifierType.OSI_IDENTIFIER:
      themeName = "osiTheme";
      break;
    default:
      themeName = "amfamTheme";
      break;
  }
  currentThemeName = themeName;
  return themeMap[themeName];
}

export const themeMap: { [key: string]: Theme } = {
  cahTheme,
  msaTheme,
  amfamTheme,
};

export { currentThemeName };
